<!-- Item wrapper -->
<div class="calsoft-vertical-navigation-item-wrapper"
    [class.calsoft-vertical-navigation-item-has-subtitle]="!!item.subtitle" [ngClass]="item.classes">

    <!-- Item with an internal link -->
    <div class="calsoft-vertical-navigation-item" [guide]="'menu-' + (item.id || item.defaultName)"
        *ngIf="item.link && !item.externalLink && !item.function && !item.disabled"
        [ngClass]="{'calsoft-vertical-navigation-item-active-forced': item.active}" [routerLink]="[item.link]"
        [routerLinkActive]="'calsoft-vertical-navigation-item-active'"
        [routerLinkActiveOptions]="{exact: item.exactMatch || false}" (click)="onItemClick()">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with a function -->
    <div class="calsoft-vertical-navigation-item" [guide]="'menu-' + (item.id || item.defaultName)"
        *ngIf="!item.link && item.function && !item.disabled"
        [ngClass]="{'calsoft-vertical-navigation-item-active-forced': item.active}" [routerLink]="[item.link]"
        [routerLinkActive]="'calsoft-vertical-navigation-item-active'"
        [routerLinkActiveOptions]="{exact: item.exactMatch || false}" (click)="item.function(item)">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with an internal link and function -->
    <div class="calsoft-vertical-navigation-item" [guide]="'menu-' + (item.id || item.defaultName)"
        *ngIf="item.link && !item.externalLink && item.function && !item.disabled"
        [ngClass]="{'calsoft-vertical-navigation-item-active-forced': item.active}" (click)="onItemClick()">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item with a no link and no function -->
    <div class="calsoft-vertical-navigation-item" [guide]="'menu-' + (item.id || item.defaultName)"
        *ngIf="!item.link && !item.function && !item.disabled"
        [ngClass]="{'calsoft-vertical-navigation-item-active-forced': item.active}">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

    <!-- Item is disabled -->
    <div class="calsoft-vertical-navigation-item calsoft-vertical-navigation-item-disabled" *ngIf="item.disabled">
        <ng-container *ngTemplateOutlet="itemTemplate"></ng-container>
    </div>

</div>

<!-- Item template -->
<ng-template #itemTemplate>
    <!-- Icon -->
    <div 
    *ngIf="!item.icon || item.icon.length === 0; else other_content" class="calsoft-vertical-navigation-item-icon"
        style="background-color: hsla(0,0%,100%,.05);
                     width: 28px;
                     height: 28px;
                     line-height: 28px;
                     font-size: 12px;
                     text-align: center;
                     border-radius: 50%;
                     margin-right: 12px;">
        {{ generateLetterIcon(item.title) | titlecase }}
    </div>

    <ng-template #other_content>
        <div *ngIf="item.svgIcon==1; else svg_icon">
            <mat-icon class="calsoft-vertical-navigation-item-icon" [ngClass]="item.iconClasses" [svgIcon]="item.icon"
                [matTooltip]="item.tooltip || item.title || item.name" matTooltipPosition="right">
            </mat-icon>
        </div>

        <ng-template #svg_icon>
            <mat-icon class="calsoft-vertical-navigation-item-icon" [ngClass]="item.iconClasses" *ngIf="item.icon"
                [matTooltip]="item.tooltip || item.title || item.name" matTooltipPosition="right">
                {{item.icon}}
            </mat-icon>
        </ng-template>
    </ng-template>

    <!-- Title & Subtitle -->
    <div class="calsoft-vertical-navigation-item-title-wrapper">
        <div class="calsoft-vertical-navigation-item-title">{{item.defaultName }}</div>
        <div class="calsoft-vertical-navigation-item-subtitle" *ngIf="item.subtitle">
            {{item.subtitle | titlecase }}
        </div>
    </div>

    <!-- Badge -->
    <div class="calsoft-vertical-navigation-item-badge" *ngIf="item.badge">
        <div class="calsoft-vertical-navigation-item-badge-content"
            [ngClass]="[(item.badge.style != undefined ? 'calsoft-vertical-navigation-item-badge-style-' + item.badge.style : ''),
                             (item.badge.background != undefined && !item.badge.background.startsWith('#') ? item.badge.background : ''),
                             (item.badge.color != undefined && !item.badge.color.startsWith('#') ? item.badge.color : '')]"
            [ngStyle]="{'background-color': item.badge.background, 'color': item.badge.color}">
            {{item.badge.title | titlecase }}
        </div>
    </div>
</ng-template>